/**
 * Order utility functions for Sales Orders management.
 */

/**
 * Checks whether an order is an Agency Customer order (đơn bán buôn cho khách hàng là Đại lý)
 * vs a Retail Customer order (đơn bán lẻ cho Khách lẻ).
 *
 * NOTE:
 * When an agency (e.g. Vmake) sells to a retail customer (khách lẻ):
 * - order.customer_type is 'END_USER'
 * - order.end_user / order.end_user_id represents the retail customer
 * - order.agency_id is set to the selling agency (Vmake)
 *
 * Such orders must NOT be treated as agency customer orders and must NOT be added
 * to the dealer's aggregated debt!
 */
export const isAgencyCustomerOrder = (order) => {
  if (!order) return false;

  const cType = order.customer_type || order.customerType;
  if (cType === 'END_USER') return false;
  if (cType === 'AGENCY') return true;

  // If order has retail end-user info, it is definitely a retail order
  if (order.end_user_id || order.end_user) return false;

  // Fallback for legacy orders where customer_type is missing:
  const agId = order.agency_id || order.agency?.id;
  if (!agId) return false;

  const agName = (order.agency?.name || '').trim().toLowerCase();
  const custName = (order.customer_name || order.customerName || '').trim().toLowerCase();

  // If order has an explicit customer name that differs from the agency name, it's a retail order
  if (custName && agName && custName !== agName) {
    return false;
  }

  // If no retail customer indicator exists and agency is present
  return true;
};

export const ORDER_STATUS_CONFIG = {
  '-1': { label: 'Đã hủy', color: '#666', bg: '#f5f5f5' },
  0: { label: 'Chưa xử lý', color: '#e67e22', bg: '#fef9e7' },
  1: { label: 'Đang xử lý', color: '#2980b9', bg: '#eaf4fb' },
  2: { label: 'Đang vận chuyển', color: '#8e44ad', bg: '#f5eef8' },
  3: { label: 'Đã giao hàng', color: '#27ae60', bg: '#eafaf1' }
};

export const ORDER_STATUS_OPTIONS = [
  { value: 0, label: 'Chưa xử lý', color: '#e67e22', bg: '#fef9e7' },
  { value: 1, label: 'Đang xử lý', color: '#2980b9', bg: '#eaf4fb' },
  { value: 2, label: 'Đang vận chuyển', color: '#8e44ad', bg: '#f5eef8' },
  { value: 3, label: 'Đã giao hàng', color: '#27ae60', bg: '#eafaf1' },
  { value: -1, label: 'Đã hủy', color: '#666', bg: '#f5f5f5' }
];
